import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CREW } from "../../content";
import { Reveal, Eyebrow } from "./Reveal";
import { CrewPhoto } from "./CrewPhoto";

export const Crew = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="crew" data-testid="crew-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div ref={ref} className="relative sticker rounded-[36px] overflow-hidden aspect-[4/3] -rotate-2">
            <motion.img
              style={{ y, scale: 1.18 }}
              src="/images/crew3.jpg"
              alt="Kids setting up big colorful YAY! yard sign letters while a parent helps"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <Eyebrow color="var(--coral)">Meet the crew</Eyebrow>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95]">
              Tiny business. <br />Big work ethic.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-[var(--ink-soft)] leading-relaxed max-w-lg">
              We're neighborhood kids learning how to run a real business: talking to customers, showing up on time and
              saving what we earn. Our parents handle the driving and keep us safe.
            </p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-4">
            {CREW.map((c, i) => (
              <Reveal key={c.name} delay={i * 0.07}>
                <motion.div
                  whileHover={{ y: -6, rotate: i % 2 ? 2 : -2 }}
                  data-testid={`crew-card-${i}`}
                  className="sticker-sm rounded-2xl bg-white p-4 h-full"
                >
                  {c.age !== "parent" && <CrewPhoto c={c} />}
                  <p className="font-display font-semibold text-lg mt-3">{c.name}</p>
                  <p className="text-sm text-[var(--ink-soft)]">{c.role} · {c.age}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="mt-8">
            <Link
              to="/crew"
              data-testid="crew-meet-all-btn"
              className="inline-flex items-center gap-2 sticker-sm rounded-full bg-[var(--sun)] font-display font-semibold px-6 py-3"
            >
              Meet the whole crew <ArrowRight size={18} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
